/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type appTrello_viewer = {
    readonly id: string;
    readonly " $refType": "appTrello_viewer";
};
export type appTrello_viewer$data = appTrello_viewer;
export type appTrello_viewer$key = {
    readonly " $data"?: appTrello_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"appTrello_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "appTrello_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
(node as any).hash = '6d1242dca180403736a61074ba2f90c4';
export default node;
